import React from "react";
import LegalLayout from "@/components/LegalLayout";

export default function TermsOfUse() {
  return (
    <LegalLayout title="Conditions Générales d'Utilisation" lastUpdate="13 février 2026">
      <h2>1. Objet</h2>
      <p>Les présentes Conditions Générales d’Utilisation (« CGU ») définissent les modalités d’accès et d’utilisation de la plateforme <strong>fripri.com</strong> éditée par l’association <strong>ECOLOVALO</strong>.</p>

      <h2>2. Accès au service</h2>
      <p>L’accès à Fripri est gratuit. La consultation du catalogue ne nécessite pas d’inscription. La vente, l’achat, la messagerie et les enchères nécessitent la création d’un compte utilisateur.</p>
      <p>Pour s’inscrire, l’utilisateur doit avoir <strong>au moins 18 ans</strong> ou disposer de l’autorisation de son représentant légal.</p>

      <h2>3. Compte utilisateur</h2>
      <p>L’utilisateur s’engage à :</p>
      <ul>
        <li>Fournir des informations exactes et à jour</li>
        <li>Choisir un mot de passe robuste et le garder confidentiel</li>
        <li>Ne pas créer plusieurs comptes</li>
        <li>Ne pas céder son compte à un tiers</li>
        <li>Signaler immédiatement toute utilisation frauduleuse</li>
      </ul>

      <h2>4. Règles de la communauté</h2>
      <p>Les utilisateurs s’engagent à respecter les principes suivants :</p>
      <ul>
        <li><strong>Honnêteté</strong> : description fidèle des articles, photos réelles, prix juste</li>
        <li><strong>Respect</strong> : pas d’insultes, harcèlement, discrimination, propos haineux dans les messages ou avis</li>
        <li><strong>Légalité</strong> : pas de contrefaçons, articles volés, dangereux, ou interdits par la loi (drogues, armes, etc.)</li>
        <li><strong>Sécurité</strong> : ne pas tenter de contourner le système de paiement séquestré (transactions en dehors de Fripri interdites)</li>
        <li><strong>Bonne foi</strong> : honorer ses ventes et ses achats dans les délais</li>
      </ul>

      <h2>5. Contenus interdits</h2>
      <p>Sont strictement interdits sur Fripri :</p>
      <ul>
        <li>Articles neufs vendus à des fins commerciales (Fripri est réservé à la seconde main entre particuliers)</li>
        <li>Contrefaçons et copies de marques</li>
        <li>Articles volés ou d’origine douteuse</li>
        <li>Sous-vêtements usagés intimes (slips, strings)</li>
        <li>Articles dangereux ou réglementés</li>
        <li>Contenus à caractère pornographique, raciste, haineux ou diffamatoire</li>
        <li>Spam, publicité non sollicitée, liens vers d’autres sites de vente</li>
      </ul>

      <h2>6. Modération</h2>
      <p>L’équipe Fripri se réserve le droit de modérer, masquer ou supprimer tout contenu non conforme, sans préavis. En cas de violation grave ou répétée, le compte peut être suspendu ou supprimé définitivement.</p>

      <h2>7. Signalement</h2>
      <p>Tout utilisateur peut signaler un contenu inapproprié, un vendeur suspect ou une transaction problématique en contactant <a href="mailto:contact@fripri.com">contact@fripri.com</a>.</p>

      <h2>8. Propriété intellectuelle</h2>
      <p>En publiant du contenu (photos, descriptions, avis) sur Fripri, l’utilisateur garantit en être l’auteur ou en détenir les droits, et concède à ECOLOVALO un droit non exclusif d’utilisation à des fins d’affichage et de promotion sur la plateforme.</p>

      <h2>9. Notifications</h2>
      <p>Les utilisateurs peuvent recevoir des notifications par email et push (navigateur) pour les événements liés à leur activité (nouvelle vente, message reçu, livraison). Les notifications push nécessitent un consentement explicite via le navigateur et peuvent être désactivées à tout moment.</p>

      <h2>10. Disponibilité</h2>
      <p>ECOLOVALO s’efforce d’assurer la disponibilité de Fripri 24h/24 et 7j/7, sans pouvoir le garantir. Le service peut être interrompu pour maintenance, mise à jour, ou en cas de force majeure.</p>

      <h2>11. Limitation de responsabilité</h2>
      <p>ECOLOVALO ne saurait être tenue responsable :</p>
      <ul>
        <li>Des contenus publiés par les utilisateurs</li>
        <li>Des transactions entre utilisateurs (voir <a href="/cgv">CGV</a>)</li>
        <li>D’une indisponibilité temporaire du service</li>
        <li>Des dommages indirects (perte de profit, perte de chance, etc.)</li>
      </ul>

      <h2>12. Suspension et clôture</h2>
      <p>L’utilisateur peut clôturer son compte à tout moment depuis son Tableau de bord. ECOLOVALO peut suspendre ou clôturer un compte en cas de violation des CGU, après notification (sauf urgence ou fraude avérée).</p>

      <h2>13. Modification des CGU</h2>
      <p>ECOLOVALO se réserve le droit de modifier les présentes CGU. Toute modification substantielle sera notifiée par email aux utilisateurs avec un délai de 15 jours avant entrée en vigueur.</p>

      <h2>14. Droit applicable</h2>
      <p>Les CGU sont soumises au droit français. En cas de litige, les tribunaux français sont seuls compétents.</p>

      <h2>15. Contact</h2>
      <p>Pour toute question : <a href="mailto:contact@fripri.com">contact@fripri.com</a> · 09 70 70 94 24</p>
    </LegalLayout>
  );
}
